import { render, staticRenderFns } from "./GoodsOrderList.vue?vue&type=template&id=2f8c2b31&"
import script from "./GoodsOrderList.vue?vue&type=script&lang=js&"
export * from "./GoodsOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports